import { Box, Card, CardBody, HStack, Text } from '@chakra-ui/react';
import { Championnat } from 'features/championnats/championnat.types';
import { useNavigate } from 'react-router-dom';
import { RoutePath } from 'router/routes.paths';

export default function ChampionnatPersonnaliseActifCard({
  championnat,
}: {
  championnat: Championnat;
}) {
  const navigate = useNavigate();
  return (
    <Card
      cursor="pointer"
      onClick={() => navigate(`${RoutePath.championnats}/${championnat.id}`)}
    >
      <CardBody>
        <HStack justify="space-between">
          <Box>
            <Text textTransform="uppercase">{championnat.name}</Text>
            <Text fontSize="sm">Championnat personnalisé</Text>
          </Box>
          <Box backgroundColor="green.400" borderRadius="full" boxSize="2" />
        </HStack>
      </CardBody>
    </Card>
  );
}
